import { flushSync } from 'react-dom';
import type { NavigateFunction } from 'react-router';

export type NavDirection = 'forward' | 'back';

/**
 * Sub-page navigation (You → section, later task detail) with the View Transitions API:
 * slides in from the end, out on back, 250 ms. Browsers without it get the CSS fallback
 * (`.animate-slide-in` on mount) and reduced motion gets a plain cut. Tab switches never use
 * this: they stay instant.
 */
export function navigateWithTransition(
  navigate: NavigateFunction,
  to: string,
  direction: NavDirection,
): void {
  const root = document.documentElement;
  root.dataset.navDirection = direction;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!document.startViewTransition || reduced) {
    void navigate(to);
    return;
  }
  const transition = document.startViewTransition(() => {
    flushSync(() => {
      void navigate(to);
    });
  });
  void transition.finished.finally(() => {
    delete root.dataset.navDirection;
  });
}

export function supportsViewTransitions(): boolean {
  return typeof document !== 'undefined' && typeof document.startViewTransition === 'function';
}
